<template>
	<div i="components-photobrowser">
		<ul id="photobrowser">
			<template v-if="type==1">
				<li><img :data-original="imgData" :src="imgData" alt="图片1"></li>
			</template>

			<template v-if="type==2">
				<li v-for="(data,index1) in imgData" :key="index1">
					<img :data-original="param.name?(data[param.name]?data[param.name]:data):data" :src="param.name?(data[param.name]?data[param.name]:data):data" :alt="param.detail?data[param.detail]:'图片'+index1">
				</li>
			</template>

			<template v-if="type==3">
				<li><img :data-original="imgData[param.name]" :src="imgData[param.name]" :alt="param.detail?(imgData[param.detail]?imgData[param.detail]:'图片'+index):'图片'+index"></li>
			</template>
		</ul>
		<!--<div class="iconfont icon-llmainpageback photobrowser-prev"></div>-->
	</div>
</template>
<style rel="stylesheet/scss" lang="scss">
	@import "../../components/photobrowser/viewer.min.css";
	@import "../../components/photobrowser/font/iconfont.css";
	[i="components-photobrowser"] #photobrowser {
		display: none;
	}
	
	[i="components-photobrowser"] .photobrowser-prev {
		color: rgba(255, 255, 255, 0.3);
		font-size: 50px;
		position: absolute;
		z-index: 2020;
		top: 500px;
		left: 20%;
	}
	[i="components-photobrowser"] .viewer-button {
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background-color: transparent;
		border-radius: 0;
	}
	[i="components-photobrowser"] .viewer-button:before{
		bottom: auto;
		left: auto;
		right: 15px;
		top: 15px;
	}
	[i="components-photobrowser"] .viewer-canvas{
		z-index: 2;
	}
	[i="components-photobrowser"] .viewer-player{
		z-index: 2;
	}
	[i="components-photobrowser"] .viewer-tooltip{
		z-index: 2;
	}
	[i="components-photobrowser"] .viewer-footer{
		z-index: 2;
	}
</style>
<script>
	import Viewer from "../../components/photobrowser/viewer.min.js";
	import "../../components/photobrowser/font/iconfont.js";

	export default {
		data() {
			return {
				type: 0,
				viewer: undefined
			};
		},
		components: {},
		props: ["imgData", "param", "index"],
		watch: {
			imgData(val) {
				this.initImg(val);
			},
			index() {
				if(this.viewer) {
					this.viewer.show();
					this.viewer.index = this.type == 2?this.index:0;
				}else{
					this.initImg(this.imgData,true);
				}
			}
		},
		computed: {},
		methods: {
			//初始化图片列表
			initImg: function(data,state) {
				var that = this;
				
				if(typeof data == "string") { //是一个图片
					this.type = 1;
				} else if(data instanceof Array) { //是一个数组				
					this.type = 2;
					if(typeof data[0] == "object") { //判断第一个数据是不是对象
						if(!this.param.name || this.param.name == "") {
							console.error('找不到图片字段，请设置param的name属性');
							return;
						}
					}
				} else if(typeof data == "object") { //是一个数组对象
					this.type = 3;
					if(!this.param.name || this.param.name == "") {
						console.error('找不到图片字段，请设置param的name属性');
						return;
					}
				}

				if(this.type > 0) {
					this.$nextTick(function() {
						that.initPhoto(state);
					})
				}
			},
			// 初始化百度编辑器
			initPhoto: function(state) {
				var that = this;

				if(that.viewer) { //第二次打开
					that.viewer.destroy();
				}
				
				var photobrowser = document.getElementById("photobrowser");

				this.viewer = new Viewer(photobrowser, {
					url: "data-original",
					show: function(e) {
						if(that.viewer.index > that.imgData.length - 1) {
							console.error('index属性索引值超出数组长度');
							return;
						}
						that.viewer.index = that.type == 2?that.index:0;
					},
					hide: function() { //关闭隐藏						
						that.$emit('update:index', 'undefined');
						if($('body').hasClass("viewer-open")){
							$('body').removeClass("viewer-open")
						}
					},
					toolbar: that.type==1?false:true,
					navbar: that.type==1?false:true
				});
				
				
				setTimeout(function() {
					state?that.viewer.show():false;					
				}, 100);
			}
		},
		mounted() {
			var that = this;
			
			setTimeout(()=>{
				that.initImg(this.imgData,true);
			},20)
		}
	};
</script>


// WEBPACK FOOTER //
// Photobrowser.vue?0d0bc97a